import React, { Component } from "react";
import { connect } from "react-redux";
import Pagination from "../../paginator2/Paginator";
// import Pagination1 from "../../paginator3/Paginator";
import Loading from "../../common/Loading";
import { searchPropResiSales } from "../../../actions/propertyResiAction_Dwk";

import { openModal } from "../../../actions/modalAction";
import { Icon } from "semantic-ui-react";
import PropResiSummary from "./PropResiSummary";

class PropResiSaleSearchList extends Component {
  state = {
    pageO: "",
    id: "",
  };
  componentDidMount() {
    const values = (this.props.form !== undefined &&
      this.props.form.values) || { localityA: [] };

    const { offsetRS, limitRS } = this.props;

    this.props.searchPropResiSales(values, limitRS, offsetRS);
  }
  handleSearchPropResiSale = () => {
    this.props.openModal("SearchModal", { propRS_Dwk: true });
  };

  //*******************************************************

  handleRefresh = () => {
    const { offsetRS, limitRS } = this.props;
    const values =
      (this.props.form !== undefined && this.props.form.values) || {};

    this.props.searchPropResiSales(values, limitRS, offsetRS);
  };

  //^^^^^^^^^^^^^^^^^^^^^^^^^
  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  //*******************************************************

  back = () => {
    const {
      //countRS,
      offsetRS,
      limitRS,
    } = this.props;
    const values = (this.props.form !== undefined &&
      this.props.form.values) || { localityA: [] };
    if (offsetRS === 0) {
      return;
    }

    this.props.searchPropResiSales(values, limitRS, offsetRS - limitRS);
    window.scroll(0, 0);
  };

  advance = () => {
    const { countRS, offsetRS, limitRS } = this.props;
    const values = (this.props.form !== undefined &&
      this.props.form.values) || { localityA: [] };
    if (offsetRS + limitRS > countRS) {
      return;
    }

    this.props.searchPropResiSales(values, limitRS, offsetRS + limitRS);
    window.scroll(0, 0);
  };

  //***************** */

  handleGoToPage2 = (page) => {
    const { limitRS } = this.props;
    const values = (this.props.form !== undefined &&
      this.props.form.values) || { localityA: [] };

    this.props.searchPropResiSales(values, limitRS, (page - 1) * limitRS);
    window.scroll(0, 0);
  };
  //****************** */

  renderLoading = () => {
    if (this.props.fetchingRS === true) {
      return <Loading />;
    }
  };

  renderNoProperty = () => {
    if (this.props.propresisRS.length === 0) {
      return (
        <div>
          <span style={{ fontSize: "18px", color: "teal" }}>
            <b>NO PROPERTY AVAILABLE </b>
          </span>
        </div>
      );
    }
  };

  render() {
    return (
      <div className="maindiv-820">
        <div className="card-attached" style={{ textAlign: "center" }}>
          {/**/}
          <div className="border-heading color-CornflowerBlue flex-center pxy-10">
            <div
              style={{ flex: "15%" }}
              onClick={this.handleSearchPropResiSale}
            >
              <span className="tag-button">
                {" "}
                <Icon name="search" />
              </span>
            </div>

            <div
              style={{ display: "flex", flex: "80%", justifyContent: "center" }}
            >
              <div className="font-20B ml-05 color-head-prop">
                {this.props.countRS} Residential Property For Sale in{" "}
                {this.props.city}
              </div>
            </div>
          </div>
          {/**/}
        </div>
        {/*  */}

        <div>
          {this.renderLoading()}

          {this.props.propresisRS.map((item) => (
            <PropResiSummary
              handleRefresh={this.handleRefresh}
              key={item._id}
              propresi={item}
            />
          ))}
        </div>

        <div className="card-attached flex-center direction-column ">
          {this.props.propresisRS !== undefined &&
            this.props.propresisRS.length && (
              <Pagination
                changePage={this.handleGoToPage2}
                advance={this.advance}
                back={this.back}
                page={
                  this.props.offsetRS === 0
                    ? 1
                    : Math.ceil(this.props.offsetRS / this.props.limitRS + 1)
                }
                pages={Math.ceil(this.props.countRS / this.props.limitRS)}
              />
            )}
        </div>
        {/* <div className="card-attached flex-center direction-column ">
          {this.props.propresisRS !== undefined &&
            this.props.propresisRS.length && (
              <Pagination1
              setPageNo={this.handleGoToPage2}
                pageNo={
                  this.props.offsetRS === 0
                    ? 1
                    : Math.ceil(this.props.offsetRS / this.props.limitRS + 1)
                }
                pages={Math.ceil(this.props.countRS / this.props.limitRS)}
              />
            )}
        </div> */}

        {/*  */}

        <br />
        <br />
      </div>
    );
  }
}

const mapStateToProps = ({ dwk_resi_property, auth, form }) => {
  const { city, fetchingRS, limitRS, offsetRS, countRS } = dwk_resi_property;

  return {
    city,
    fetchingRS,
    limitRS,
    offsetRS,
    countRS,
    form: form.PropResiSaleSearch,
    propresisRS: dwk_resi_property.propresisRS,
    userA: auth.userA,
  };
};

export default connect(mapStateToProps, { searchPropResiSales, openModal })(
  PropResiSaleSearchList
);
